<template>
    <button :type="type" class="button-secondary">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'submit',
            },
        }
    }
</script>

<style scoped>
button::before {
  content: "\203A";
  display: inline-block;
  margin-right: 5px;
}
</style>
